
/*jshint loopfunc:true */
import React, { Component } from "react";
import "./Attable.css";
import * as helpers from "../helpers/helpers";

class Attable extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  
  }

  componentDidMount() {
   
    this.setState({  });
  }

  toggleAtTable() {
    helpers.waitForLoad("settings", Date.now(), 30, () => {
    const elBtn = document.getElementById("esp-btnAttable");
    const elTable = document.getElementById("esp-attable");
    elBtn.classList.toggle("activateBtn");
    //elTable.classList.toggle("activeTable");
        console.log(parseInt(document.defaultView.getComputedStyle(elTable).height));
        parseInt(document.defaultView.getComputedStyle(elTable).height) > 0 ?  elTable.style.setProperty("height", '0px') : elTable.style.setProperty("height", '400px');
   
    });
}

dragAtTable(e) {
    
    helpers.waitForLoad("settings", Date.now(), 30, () => {
        let dragable = document.getElementById("esp-attable");       
        var startY, startHeight;

        function initDrag(e) {
        startY = e.clientY;
        startHeight = parseInt(document.defaultView.getComputedStyle(dragable).height, 10);
        document.documentElement.addEventListener('mousemove', doDrag, false);
        document.documentElement.addEventListener('mouseup', stopDrag, false);
        }

        initDrag(e);

        function doDrag(e) {       
            dragable.style.setProperty("height", (startHeight - e.clientY + startY) + 'px', "important");
         }
         
         function stopDrag(e) {
             document.documentElement.removeEventListener('mousemove', doDrag, false);  
             document.documentElement.removeEventListener('mouseup', stopDrag, false);
         }
        
    });
}


  render() {

    return (
        <div className="map-theme">
                <div id="esp-blockAttable" className="mapAtTable">
                    <div id="esp-btnAttable" className="btnAttable" onClick={this.toggleAtTable}>
                    </div>
                    <div id="esp-dragAttable" className="dragAttable" onMouseDown={this.dragAtTable}>
                    </div>
                    <div id="esp-attable" className="attable">
                    </div>
                </div>
            </div>
    )
  }
}

export default Attable;